module.exports = __webpack_public_path__ + "static/media/WEBnegro_19.950d942a.png";